import React, { useRef, useState } from "react";
import Accordion from "react-bootstrap/Accordion";
import { Link } from "react-router-dom";
const Accordioncommon = (props) => {
    const [selectedKey, setSelectedKey] = useState(props.defaultActiveKey ? props.defaultActiveKey : "");
    const scrollRef = useRef(null);
    const scrollToTop = () => {
        scrollRef &&
            scrollRef.current &&
            scrollRef.current.scroll({
                top: 0,
                behavior: "smooth",
            });
    };
    React.useEffect(() => {
        if (props.defaultActiveKey)
            setSelectedKey(props.defaultActiveKey);
    }, [props.defaultActiveKey]);
    return (React.createElement(React.Fragment, null,
        props.maintitle && React.createElement("div", null, props.maintitle),
        React.createElement(Accordion, { activeKey: selectedKey, onSelect: (key) => setSelectedKey(key), className: `customaccordian ${props.parentClass}` }, props.AccordionArray &&
            props.AccordionArray.map((accordiandata, idx) => {
                return (React.createElement(Accordion.Item, { key: idx, eventKey: accordiandata.eventKey },
                    React.createElement(Accordion.Header, { as: Link, to: accordiandata.route ? accordiandata.route : "", onClick: () => {
                            props.handleTitle && props.handleTitle(accordiandata.title);
                        } }, accordiandata.title),
                    React.createElement(Accordion.Body, null,
                        React.createElement("div", { key: idx, ref: accordiandata.eventKey === selectedKey &&
                                accordiandata.backToTop
                                ? scrollRef
                                : null, id: "accordion-content", className: `${props.innerClassName} ${accordiandata.backToTop && "setHeight"}` }, accordiandata.tabContent),
                        accordiandata.backToTop && (React.createElement("div", { className: "accordian-back EncodeSans_12_500 txt-midnight-blue d-flex justify-content-end mt-2", onClick: () => scrollToTop() },
                            React.createElement("i", { className: "edel-icon-point-arrow-up" }),
                            React.createElement("span", null, "Back to top"))))));
            }))));
};
export default Accordioncommon;
